import React from "react"
import { get, flattenDeep } from "lodash"
import APIs from "redux/apis"
import { APIResponse } from "redux/apis/types"
import { tableColumns } from "config/table_columns"
import { Sort } from "utils/sort"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"

/************************
 * トップ＞ワールドサマリ＞ミニチャート
 ***********************/
type miniChartProps = {
  updateChart: Function
}

//API
export const miniChartApi = async (props: miniChartProps) => {
  const priceList: APIResponse.Res | {} = await APIs.SymbolDetail.PriceList({
    Name: "Top.Summary.Benchmark",
  })
  props.updateChart(get(priceList, "ResultList"))
}

/************************
 * トップ＞ワールドサマリ＞指数
 * ・ベンチマーク
 * ・株式指数
 * ・外国為替
 * ・国債
 * ・商品
 * ・政策金利
 ***********************/

type apiParamList =
  | "Top.Summary.Benchmark"
  | "Top.Summary.Index.World"
  | "Top.Summary.Index.Jpn"
  | "Top.Summary.Index.Asian"
  | "Top.Summary.Index.Other"
  | "Top.Summary.Index.All"
  | "Top.Summary.FX.World"
  | "Top.Summary.FX.Asian"
  | "Top.Summary.FX.Other"
  | "Top.Summary.FX.All"
  | "Top.Summary.GB.World"
  | "Top.Summary.GB.Asian"
  | "Top.Summary.GB.Other"
  | "Top.Summary.GB.All"
  | "Top.Commodity"
  | "Top.PIR"

type Props = {
  indexTypeNum: number
  marketScopeNum: number
  apiParam: apiParamList | {}
  changeIndex: Function
}

const tableTypes = [
  [
    tableColumns.index.summary,
    tableColumns.index.currencySummary,
    tableColumns.index.interest,
  ],
  [tableColumns.index.summary],
  [tableColumns.index.currencySummary],
  [tableColumns.index.interest],
  [tableColumns.instrument.top],
  [tableColumns.bank_rate.summary],
]

const marketTypes = [
  [],
  [Sort.IndexCountry],
  [Sort.IndexCountryFX],
  [Sort.IndexCountryGB],
  [],
  [],
]

const links: Array<Array<string> | string> = [
  ["/top/index", "/top/exchange", "/top/bonds"],
  "/top/index",
  "/top/exchange",
  "/top/bonds",
  "/top/instrument",
  "/top/bank_rate",
]

//API
export const indexApi = async (props: Props) => {
  const loadResistId = uuid()
  store.dispatch(pageLoadRegist(loadResistId, true))
  const priceList: APIResponse.Res | {} = await APIs.SymbolDetail.PriceList({
    Name: props.apiParam,
  })
  const resultList = get(priceList, "ResultList", [])
  const tableType =
    props.indexTypeNum === Sort.IndexType[0].id
      ? tableTypes[props.indexTypeNum]
      : flattenDeep(tableTypes[props.indexTypeNum])
  const marketType = flattenDeep(marketTypes[props.indexTypeNum])
  props.changeIndex({
    apiRes: resultList,
    indexType: tableType,
    indexTypeNum: props.indexTypeNum,
    marketType: marketType,
    displayRangeNum: props.marketScopeNum,
    link: links[props.indexTypeNum],
  })
  store.dispatch(pageLoadRegist(loadResistId, false))
}
